module.exports = __webpack_public_path__ + "img/hero-image.8c558157.svg";